
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Users, Plus } from 'lucide-react';

export const EmptyTeachersList = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="h-24 w-24 bg-primary/10 rounded-full flex items-center justify-center mb-6">
        <Users className="h-12 w-12 text-primary" />
      </div>
      <h3 className="text-xl font-semibold mb-2">No Teachers Found</h3>
      <p className="text-gray-500 text-center max-w-md mb-6">
        There are no teachers in the system yet. Get started by adding your first teacher.
      </p>
      <Button asChild>
        <Link to="/teachers/new">
          <Plus className="h-4 w-4 mr-2" />
          Add Your First Teacher
        </Link>
      </Button>
    </div>
  );
};
